@if (arcDepositBlockStatus?.depositBlocked) {
    <show-message [type]="messageType.ERROR">
        <div error>
            <strong>{{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.declined.msg.header' | translate }}</strong>
            <p>{{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.declined.msg.quote' | translate }}</p>
            <br />
            <p>{{ 'PARTY.CASHIER.web.arc.deposit.limits.intervention.blocked.body.msg1' | translate }}</p>
            <br />
            <p>
                {{
                    'PARTY.CASHIER.web.arc.deposit.limits.intervention.blocked.body.msg2'
                        | translate
                            : {
                                  hhmm: arcDepositBlockStatus?.expiryTime,
                                  date: arcDepositBlockStatus?.expiryDate,
                              }
                }}
            </p>
            <br />
            <p
                [vnDynamicHtml]="
                    'PARTY.CASHIER.web.arc.deposit.limits.intervention.blocked.body.msg3'
                        | translate
                            : {
                                  clickHereUrl: arcDeclinedDepositClickHereUrl,
                              }
                "></p>
        </div>
    </show-message>
}
